import api from './api';

export const enrollStudent   = (data)            => api.post('/api/enrollments', data);
export const bulkEnroll      = (data)            => api.post('/api/enrollments/bulk', data);
export const getClassEnrollments = (classId)     => api.get(`/api/enrollments/class/${classId}`);
export const getStudentEnrollments = (studentId) => api.get(`/api/enrollments/student/${studentId}`);
export const unenroll        = (id)              => api.delete(`/api/enrollments/${id}`);
export const pauseEnrollment = (id, pausedReason)=> api.put(`/api/enrollments/${id}/pause`, { pausedReason });
export const resumeEnrollment= (id)              => api.put(`/api/enrollments/${id}/resume`);
export const getMyStudents   = ()                => api.get('/api/enrollments/my-students');
